<template>
  <div class="container container-mobile">
    <Card v-if="mode" class="my-3">
      <h4>Редактирование брони</h4>

      <ul class="nav nav-underline">
        <li class="nav-item">
          <router-link :to="{ name: 'mybookings' }" class="nav-link">
            Мои бронирования
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'schedule' }" class="nav-link">
            Вернуться в расписание
          </router-link>
        </li>
      </ul>

    </Card>
    <div v-if="getUserData && !loading" class="card p-4 py-lg-2 px-lg-2 my-3 small">
      <div class="d-flex justify-content-between align-items-center gap-lg-2 flex-wrap">
        <div class="flex-nowrap  mb-lg-0 px-2">Здравствуйте, <b v-if="getUserData.firstName">{{ getUserData.firstName }}
          {{
            getUserData.lastName
          }}</b><b v-else>--</b></div>

        <div class="flex-nowrap  mb-lg-0 px-2">Ваш баланс: <b>{{ numberFormat(getUserData.userBalance) }} ₽</b> <a
            href="/add-balance" class="text-nowrap">пополнить</a></div>
        <div class="flex-nowrap  mb-lg-0 mt-3 mt-lg-0 px-2">
          <small>Присылать уведомления о бронировании:</small>
          <div class="d-flex gap-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" v-model="checkedEmailNotify" value="1"
                     id="flexCheckNotify">
              <label class="form-check-label small" for="flexCheckNotify">
                на Email
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" v-model="checkedTelegramNotify" value="1"
                     id="flexCheckNotifyTelegram" ref="flexCheckNotifyTelegram">
              <label class="form-check-label small" for="flexCheckNotifyTelegram">
                в Telegram
              </label>
            </div>
          </div>
        </div>
        <div class="flex-nowrap px-2">
          <div v-if="!isIndex">
            <router-link :to="{ name: 'mybookings' }"
                         class="mt-3 mt-lg-0  btn btn-secondary btn-sm btn-sm2 text-nowrap">
              Мои бронирования
            </router-link>
          </div>
          <div v-if="isIndex">
            <a href="/schedule/mybookings" class="btn btn-secondary btn-sm text-nowrap">
              Мои бронирования
            </a>
          </div>
        </div>
      </div>
    </div>
    <SearchForm v-if="!mode && !loading" :searchFormData="this.$store.state.searchDataForm"/>
    <div v-if="!getData || loading">
      <div class="card  px-1 py-4 p-sm-4 my-3 d-flex flex-row justify-content-center">
        <div>
          <span class="spinner-border spinner-border-sm text-primary me-2"></span>
        </div>
        <div>
          Загружаем...
        </div>
      </div>
    </div>

    <div class="card p-4 mb-3" v-if="!mode && !loading">
      <div class="d-flex flex-column flex-lg-row justify-content-between">
        <div>
          <div class="d-flex small" v-if="cabinetCount">
            <label class="fw-bold me-2">Найдено:</label>
            <div>
              {{ cabinetCount }} {{ this.wordForm(cabinetCount, ['кабинет', 'кабинета', 'кабинетов']) }} в
              {{ officeCount }} {{ this.wordForm(officeCount, ['центре', 'центрах', 'центрах']) }}
            </div>
          </div>
          <div>
            <ul class="list-inline li2 mb-0 filter-result small">
              <li class="text-nowrap"><label class="fw-bold">Параметры поиска:</label></li>
              <li class="text-nowrap">Дата: <b>{{ dateFormat }}</b></li>
              <li class="text-nowrap">Центр: <b>{{ officeTitle }}</b></li>
              <li v-if="searchData.capacity > 0" class="text-nowrap">Вместимость кабинета: <b>{{ capacityTitle }}</b>
              </li>
              <li v-if="searchData.metro > 0" class="text-nowrap">Метро: <b>{{ metroTitle }}</b></li>
              <li v-if="priceFilterTitle" class="text-nowrap">Цена: <b>{{ priceFilterTitle }}</b></li>
              <li v-if="searchData.time_to > 0 || searchData.time_from > 0" class="text-nowrap">Свободные часы:
                <b>{{ timeFilterTitle }}</b></li>
              <li v-if="searchData.cabinet_options && searchData.cabinet_options.length" class="text-nowrap">В кабинете:
                <b>{{ cabOptionsTitle }}</b></li>
              <li v-if="searchData.cabinet_types && searchData.cabinet_types.length" class="text-nowrap">Тип кабинета:
                <b>{{ cabTypesTitle }}</b></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="mt-3 alert alert-info" v-if="!officeCount">
        Мы не нашли кабинеты, соответствующие параметрам поиска. Попробуйте изменить параметры.
      </div>
    </div>

    <template v-if="$isMobile()">
      <div class="px-2 py-1 mb-3" v-if="!loading">
        <div class="d-flex justify-content-between">
          <div>
            <div class="small mb-1">Масштаб</div>
            <BtnGroupXMobile :count="3" :name="'xselect'"/>
          </div>
          <div>
            <div class="small mb-1">Режим</div>
            <BtnGroupModeMobile :name="'modeselect'"/>
          </div>
        </div>
      </div>

      <BookingTableMobile v-show="!loading" id="bookingtableMobile" v-for="(cabData,offId) in getData" :key="offId"
                          :officeId="Number(offId)"/>
    </template>
    <template v-else>
      <div class="px-2 py-1 mb-3" v-if="!loading">
        <div class="d-flex justify-content-end">
          <div>
            <div v-show="this.$store.state.vMode == 0" class="me-3">
              <div class="small mb-1">Масштаб</div>
              <BtnGroupX :count="3" :name="'xselect'"/>
            </div>
          </div>
          <div>
            <div class="small mb-1">Режим</div>
            <BtnGroupMode :name="'modeselect'"/>
          </div>
        </div>
      </div>
      <BookingTable v-show="!loading" id="bookingtable" v-for="(cabData,offId) in getData" :key="offId"
                    :officeId="Number(offId)"/>
    </template>
  </div>
  <BottomModal v-if="!loading"/>
</template>

<script>

import BookingTable from "@/components/BookingTable/BookingTable";
import BookingTableMobile from "@/components/BookingTableMobile/BookingTableMobile";
// import axios from "axios";
import BottomModal from "@/components/BookingTable/BottomModal";
import {API} from "@/getapi";
import SearchForm from "@/components/Form/SearchForm";
import {dateFormat} from "@/dateFormat";
import Card from "@/components/Card";
import BtnGroupXMobile from "@/components/BookingTableMobile/BtnGroupXMobile";
import BtnGroupModeMobile from "@/components/BookingTableMobile/BtnGroupModeMobile";
import BtnGroupX from "@/components/BookingTable/BtnGroupX.vue";
import BtnGroupMode from "@/components/BookingTable/BtnGroupMode.vue";
import {openModal} from "jenesius-vue-modal";

import InfoConnectTelegramBot from "@/components/MyBookings/InfoConnectTelegramBot.vue";
// import {store} from "@/store/vuexStore";
// import Bootstrap5Modal from "@/components/Bootstrap5Modal";

// var DOMAIN = 'https://velcro.loc';
// if (window.location.hostname != '192.168.0.107') {
//   DOMAIN = '';
// }
//
// // const DOMAIN = 'https://api.velcro.loc';
// // const DOMAIN = 'https://192.168.0.107';
// // const URL_GET = DOMAIN + '/booking/get';
// const URL_GET = DOMAIN + '/v1/api/get';
// console.log(window.location.hostname)

export default {
  components: {
    BtnGroupMode,
    BtnGroupX,
    BtnGroupXMobile,
    Card,
    SearchForm,
    BottomModal,
    BookingTable,
    BookingTableMobile,
    BtnGroupModeMobile
  },

  props: {
    mode: String
  },
  inject: [
    'URL_GET', 'URL_SETNOTIFY', 'URL_GETOFFICE', 'URL_SETNOTIFY_TELEGRAM'
  ],
  provide() {
    return {
      searchData:this.searchData,
      // сколько процентов вычитается при возврате суммы за бронь,когда просрочка по времени возврата
      percentRetention: 50,
      // URL_PAYMENT: DOMAIN + '/v1/api/payment',
      // URL_BOOKING: DOMAIN + '/v1/api/booking',
      // URL_CANCEL: DOMAIN + '/v1/api/cancel',
      // URL_MYBOOKING: DOMAIN + '/v1/api/mybooking',
      timeSlideData: this.timeSlideData,
      memoryData: this.$store.state.memoryData
    }

  },
  data() {
    return {
      checkedEmailNotify: true,
      checkedTelegramNotify: false,
      telegramNotifyConnect: false,
      telegramBotConnectUrl: '',
      loading: true,
      // Данные запомненные в куках перед пополнением баланса
      memoryData: this.$store.state.memoryData,
      timeSlideData: {
        1: "10:00",
        2: "10:30",
        3: "11:00",
        4: "11:30",
        5: "12:00",
        6: "12:30",
        7: "13:00",
        8: "13:30",
        9: "14:00",
        10: "14:30",
        11: "15:00",
        12: "15:30",
        13: "16:00",
        14: "16:30",
        15: "17:00",
        16: "17:30",
        17: "18:00",
        18: "18:30",
        19: "19:00",
        20: "19:30",
        21: "20:00",
        22: "20:30",
        23: "21:00",
        24: "21:30",
        25: "22:00"
      },
      searchData: {
        'officeId': 0,
        // 'officeIds': [],
        'date': "",
        'capacity': 0,
        'metro': 0,
        'price_start': 0,
        'price_end': 1500,
        'time_to': 0,
        'time_from': 0,
        'cabinet_options': [],
        'cabinet_types': [],
      },
    }
  },
  beforeMount() {
    // if (this.memoryData) {
    //   if (this.memoryData.searchData) {
    //     // закинем данные по фильтру в хранилище
    //     // this.$store.commit('setSearchDataForm', this.memoryData.searchData, {root: true})
    //     // console.log('this.memoryData.searchData', this.memoryData.searchData);
    //     // this.searchData =  Object.assign(this.searchData, this.memoryData.searchData);
    //   }
    // }
  },
  mounted() {
    // this.getDataFromAPiLite()
    // подписка на изменение выбранных ячеек, и записываем в куки данные выбранные
    // this.$store.subscribe((mutation) => {
    //   if(mutation.type.startsWith("selector")){
    //       if(['selector/selectNewCellCabinet','selector/resetNewCellCabinet'].indexOf( mutation.type) != -1){
    //         let res = JSON.stringify({
    //           officeId: this.$store.state.officeSelectCurrent,
    //           officeSelectData: this.$store.state.selector.new
    //         })
    //         this.$cookies.set('selectorData', res, Infinity);
    //       }
    //   }
    // })
  },
  beforeUpdate() {

  },
  updated() {
    // console.log('updated')
  },
  beforeUnmount() {
    this.$store.commit('resetSearchDataForm')
    // Don't forget the destroy event. Avoid memory leaks
    this.$emitter.off('bookingDone')
    this.$emitter.off('fakeSendForm')
    this.$emitter.off('prevDate')
    this.$emitter.off('nextDate')
    this.$emitter.off('changeDate')
    this.$emitter.off('addBalanceClick')
    this.$emitter.off('resetMemoryDataSelected')

  },
  created() {

    // if (this.memoryData == null) {
    //   this.memoryData = this.$cookies.get('selectorDataBeforeAddBalance')
    //   this.$store.dispatch('setMemoryData', this.memoryData)
    // }
    // если есть данные сохраненные перед пополнением баланса, то

    // if (this.memoryData) {
    //   if (this.memoryData.searchData) {
    //     // закинем данные по фильтру в хранилище
    //     this.$store.commit('setSearchDataForm', this.memoryData.searchData, {root: true})
    //   }
    //   // показываем один раз и стираем
    //   // todo убрать коммент включить после теста
    //   // this.$cookies.set('selectorDataBeforeAddBalance', false, -1);
    // }


    // console.log('CREATED')
    // let idOfficeSelectCurrent = this.$cookies.get('officeSelectCurrent');
    //
    // let xhr = new XMLHttpRequest();
    //
    // xhr.open('POST', this.URL_GETOFFICE, false);
    //
    // try {
    //   xhr.send();
    //   if (xhr.status != 200) {
    //     console.log(`Ошибка запроса office ID пользователя ${xhr.status}: ${xhr.statusText}`);
    //   } else {
    //     let res = JSON.parse(xhr.response);
    //     if(res.result > 0){
    //       this.$store.dispatch('setOfficeCurrent', res.result);
    //     }else{
    //       if (idOfficeSelectCurrent > 0) {
    //         this.$store.dispatch('setOfficeCurrent', idOfficeSelectCurrent);
    //       }
    //     }
    //     console.log(JSON.parse(xhr.response));
    //   }
    // } catch(err) { // для отлова ошибок используем конструкцию try...catch вместо onerror
    //   console.log("Запрос office ID пользователя не удался");
    // }

    // console.log(idOfficeSelectCurrent)
    // if (idOfficeSelectCurrent > 0) {
    //   this.$store.dispatch('setOfficeCurrent', idOfficeSelectCurrent);
    // }

    // Внесем значение x из куков
    let valX = this.$cookies.get('X');
    valX = !valX ? 2 : valX;
    this.$store.dispatch('setX', valX);
    let valVMode = this.$cookies.get('vMode');
    valVMode = !valVMode ? 0 : valVMode;
    this.$store.dispatch('setVMode', valVMode);


    this.$emitter.on('addBalanceClick', () => {
      /**
       * Запомним настройки формы поиска, дату, офис и выбранные ячейки,
       * После оплаты вернемся обратно и настройки загрузим
       */
      // let officeSelectData = Object.keys(this.$store.state.selector.new);
      // let settingsMemory = {
      //   // 'officeSelectData': officeSelectData,
      //   'officeSelectData': {},
      //   'searchData': Object.assign({}, this.searchData)
      // }

      // ставим выбранный офис, берем данные из выбранных ячеек
      // актуально, если был режим показа всех центров, но выбор был в одном
      // if (officeSelectData.length) {
      //
      //   if ('officeId' in settingsMemory.searchData && settingsMemory.searchData['officeId'] == 0) {
      //     let officeId = officeSelectData[0].split(':')[0]
      //     // console.log('officeId',officeId)
      //     this.$cookies.set('officeSelectCurrent', officeId, Infinity);
      //     this.$store.dispatch('setOfficeCurrent', officeId);
      //     settingsMemory.searchData['officeId'] = officeId;
      //   }
      // }
      //
      // console.log(settingsMemory)
      //
      //
      // this.$cookies.set('selectorDataBeforeAddBalance', settingsMemory, Infinity);

    })

    this.$emitter.on('bookingDone', () => {
      this.getDataFromAPi('bookingDone in created')
    })
    this.$emitter.on('resetMemoryDataSelected', () => {

      // if (Object.hasOwn(this.memoryData, 'officeSelectData') && this.memoryData.officeSelectData.length) {
      // console.log('resetMemoryDataSelected',this.memoryData )
      // this.memoryData = {}
      this.$store.dispatch('setMemoryData', null)
      this.$cookies.set('selectorDataBeforeAddBalance', false, -1);
      // this.$store.dispatch('selector/resetSelector')
      // console.log('resetMemoryDataSelected', this.memoryData)
      // }
    })
    this.$emitter.on('fakeSendForm', (data) => {
      for (var key in data) {
        this.searchData[key] = data[key]
      }
      this.getDataFromAPi('fakeSendForm')
      // console.log('fakeSendForm',this.searchData)
    })
    this.$emitter.on('prevDate', () => {
      if (!this.$store.state.loading) {
        let nowDate = dateFormat.formatDate(dateFormat.getDateNowWithTimeZone())
        let currentDate = new Date(this.searchData.date)

        if (dateFormat.compare(this.searchData.date, nowDate) == '>') {
          currentDate.setDate(currentDate.getDate() - 1);
          this.searchData.date = dateFormat.formatDate(currentDate)
          this.$store.commit('setSearchDataForm', this.searchData, {root: true})
          this.$emitter.emit('fakeSendForm', this.searchData)
        }
      }
    })

    this.$emitter.on('nextDate', () => {
      if (!this.$store.state.loading) {
        let currentDate = new Date(this.searchData.date)
        currentDate.setDate(currentDate.getDate() + 1);
        this.searchData.date = dateFormat.formatDate(currentDate)
        this.$store.commit('setSearchDataForm', this.searchData, {root: true})
        this.$emitter.emit('fakeSendForm', this.searchData)

      }
    })

    this.$emitter.on('changeDate', (date) => {
      if (!this.$store.state.loading) {
        let currentDate = new Date(date)
        this.searchData.date = dateFormat.formatDate(currentDate)
        this.$store.commit('setSearchDataForm', this.searchData, {root: true})
        this.$emitter.emit('fakeSendForm', this.searchData)

      }
    })

    if (this.mode && Object.keys(this.$route.query).length) {

      // this.searchData = {
      //   'officeId': this.$route.query.officeId,
      //   'date': this.$route.query.finddate,
      //   'capacity': 0,
      //   'metro': 0,
      //   'price_start': 0,
      //   'price_end': 700,
      //   'time_to': 0,
      //   'time_from': 0,
      // }

      this.searchData.date = this.$route.query.finddate
      this.searchData.officeId = this.$route.query.officeId;
      // console.log('CREATED watch', this.$route.query, this.searchData.date)
      this.getDataFromAPi('start -2')
    } else {
      if (Object.keys(this.$store.state.searchDataForm).length) {
        let d = this.$store.state.searchDataForm;
        this.searchData.officeId = d.officeId;
        this.searchData.date = d.date;
        this.searchData.capacity = d.capacity;
        this.searchData.time_to = d.time_to;
        this.searchData.time_from = d.time_from;
        this.searchData.cabinet_options = d.cabinet_options || [];
        this.searchData.cabinet_types = d.cabinet_types || [];
        this.getDataFromAPi('start -1')
      } else {
        this.start()
        this.getDataFromAPi('start')
      }

    }

  },
  computed: {
    isIndex() {
      return !(window.location.href.indexOf("schedule/") > -1)
    },
    finddate() {

      return this.$route.query.finddate ? this.$route.query.finddate : '0'
    },
    timeFilterTitle() {
      let from = this.searchData.time_from
      let to = this.searchData.time_to
      return from > 0 ? 'c ' + this.timeSlideData[from] + ' до ' + this.timeSlideData[to] : 'Все возможные'
    },

    cabOptionsTitle() {
      let cabOps = this.searchData.cabinet_options
      let str = 'Не важно';
      if (cabOps) {
        cabOps.forEach(function (item, i) {

          if (i) {
            str += ', '
          } else {
            str = ''
          }
          str += item['name']
        });
      }
      return str
    },
    cabTypesTitle() {
      let cabTypes = this.searchData.cabinet_types
      let str = 'Не важно';
      if (cabTypes) {
        cabTypes.forEach(function (item, i) {

          if (i) {
            str += ', '
          } else {
            str = ''
          }
          str += item['name']
        });
      }
      return str
    },
    priceFilterTitle() {
      let from = this.searchData.price_start
      let to = this.searchData.price_end
      return (from > 0 ? 'от ' + from + ' ₽ ' : '') + 'до ' + to + ' ₽'
    },
    metroTitle() {
      return this.$store.state.metroSelect[this.searchData.metro]
    },
    capacityTitle() {
      return this.$store.state.cpacitySelect[this.searchData.capacity]
    },
    officeTitle() {
      let offc = this.searchData.officeId
      if (offc == 'all') {
        return 'Все'
      }
      // return this.$store.state.officeSelect[this.searchData.officeId]
      return this.$store.state.officeSelect[this.$store.state.officeSelectCurrent]
    },
    dateFormat() {
      return dateFormat.strToFormat(this.searchData.date)
    },
    getUserData() {
      return this.isSet(this.$store.state.user) ? this.$store.state.user : false
    },
    officeCount() {
      if (this.isSet(this.$store.state.office.data)) {
        return Object.keys(this.$store.state.office.data).length
      }
      return 0
    },
    cabinetCount() {
      // if(!this.officeCount) return  0
      if (!this.$store.state.cabinet.data.cabinetsInfo) return 0
      let count = 0
      var size = Object.keys(this.$store.state.cabinet.data.cabinetsInfo).length
      if (size) {
        // console.log(this.$store.state.cabinet.data)
        for (var key in this.$store.state.cabinet.data.cabinetsInfo) {

          count += Object.keys(this.$store.state.cabinet.data.cabinetsInfo[key]).length
        }
      }
      return count
    },
    getData() {
      return this.$store.state.cabinet.data.cabinetsInfo;
    }
  },
  watch: {
    checkedTelegramNotify(val) {

      if (this.telegramNotifyConnect === false && val === true) {
        var props = {
          url: this.telegramBotConnectUrl
        }
        openModal(InfoConnectTelegramBot, props);
        this.checkedTelegramNotify = false;
        this.$refs.flexCheckNotifyTelegram.checked = false;
      } else {
        API.get(this.URL_SETNOTIFY_TELEGRAM, {
          'status': val
        }).then(({data}) => {
          if (data.isOk) {
            console.log('ok')
          } else {
            console.error("Error:", data.errors)
          }
        }).catch((err) => {
          API.catch(err)
        })
      }
    },
    checkedEmailNotify(val) {

      API.get(this.URL_SETNOTIFY, {
        'status': val
      }).then(({data}) => {
        if (data.isOk) {
          console.log('ok')
        } else {
          console.error("Error:", data.errors)
        }
      }).catch((err) => {
        API.catch(err)
      })

    },
    mode(val) {
      if (!val) {
        this.loading = true;
        this.start()
      }
    },
    searchData: {
      handler() {
        // console.log('WATCH')
        this.$store.commit('setDate', this.searchData.date, {root: true})
        // this.getDataFromAPi('watch')
      },
      deep: true
    }
  },
  methods: {
    // getMemoryData(){
    //
    //   return this.$store.state.memoryData
    //   if (this.memoryData == null){
    //     this.memoryData = this.$cookies.get('selectorDataBeforeAddBalance')
    //   }
    //   return this.memoryData
    // },
    numberFormat(number) {
      if (isNaN(Number(number))) {
        return '-.-';
      }

      return new Intl.NumberFormat("ru", {minimumFractionDigits: 2}).format(number).replace(',', '.');
    },
    start() {
      let currentDate = dateFormat.getDateNowWithTimeZone()
      console.log('start');
      // currentDate.setDate(currentDate.getDate() + 1);
      this.searchData.date = dateFormat.formatDate(currentDate)

      if (this.$store.state.officeSelectCurrent) {
        this.searchData.officeId = this.$store.state.officeSelectCurrent;
      }

    },
    isSet(val) {
      return typeof val !== 'undefined'
    },
    // склонение слов
    wordForm(num, word) {
      let cases = [2, 0, 1, 1, 1, 2];
      return word[(num % 100 > 4 && num % 100 < 20) ? 2 : cases[(num % 10 < 5) ? num % 10 : 5]];
    },
    bookingDone() {
      console.log('bookingDone')
    },
    // btnClick(officeId) {
    //   if (typeof officeId !== "object") {
    //     officeId = [officeId];
    //   }
    //   this.searchData.officeIds = officeId;
    // },

    // Функция для проверки даты
    checkDate(dateStr) {
      // Создаем объект Date из строки
      let inputDate = new Date(dateStr);
      // Получаем сегодняшнюю дату
      let today = new Date();

      // Обнуляем время у сегодняшней даты и даты из строки
      inputDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      // Проверяем, прошла ли дата
      if (inputDate < today) {
        // Если дата прошла, устанавливаем сегодняшнюю дату
        inputDate = today;
      }

      // Форматируем дату в формате YYYY-MM-DD
      const year = inputDate.getFullYear();
      const month = String(inputDate.getMonth() + 1).padStart(2, '0'); // Месяцы начинаются с 0
      const day = String(inputDate.getDate()).padStart(2, '0');

      // Возвращаем дату в формате YYYY-MM-DD
      return `${year}-${month}-${day}`;
    },
    getDataFromAPi(a) {
      console.log('getDataFromAPi', a);
      if (!this.$store.state.loading) {

        this.$store.commit('setLoading', true, {root: true})

        // this.searchData.date = '2024-07-31'
        // проверим что дата запроса текущая или позже. Иначе бэк даст ошибку
        let chDate = this.checkDate(this.searchData.date)

        if(chDate !=this.searchData.date){
          console.log('Коррекция даты c ', this.searchData.date, 'на', chDate)
          this.searchData.date = chDate
        }
        console.log('this.searchData ', this.searchData)

        let _this = this;
        API.get(this.URL_GET, this.searchData).then(({data}) => {
          if (data.isOK) {
            console.log(this.memoryData)
            // if ('officeSelectData' in this.memoryData['officeSelectData']){
            _this.$store.dispatch('selector/resetSelector')
            // }

            _this.$store.commit('setLoading', false, {root: true});

            _this.$store.dispatch('setData', data.result);
            this.searchData.officeId = data.result.currentOfficeId;
            // if('user' in data.result && 'defaultOffice' in data.result.user && data.result.user.defaultOffice > 0 ){
            //   console.log(data.result.user.defaultOffice)
            //   this.$store.dispatch('setOfficeCurrent', data.result.user.defaultOffice);
            //   this.searchData.officeId = data.result.user.defaultOffice;
            // }
            this.loading = false
            this.checkedEmailNotify = data.result.user.notifyEmail ? true : false;
            this.checkedTelegramNotify = data.result.user.notifyTelegram ? true : false;
            this.telegramNotifyConnect = data.result.user.telegramNotifyConnect ? true : false;
            this.telegramBotConnectUrl = data.result.user.telegramBotConnectUrl;

            console.log(data.result);
          } else {
            console.error("Error:", data)
            _this.$store.commit('setLoading', false, {root: true});
          }
        }).catch((err) => {
          _this.$store.commit('setLoading', false, {root: true});
          API.catch(err)
        })
      } else {
        console.log('Busy. Loading...')
      }
    }
  }
}
</script>


<style>
:root {
  --slider-handle-width: 20px;
  --slider-handle-height: 20px;
}

.Vue-Toastification__toast.custom-toast-class {
  min-height: 43px;
  padding: 10px 24px;
}

.Vue-Toastification__toast--info.custom-toast-class {
  background-color: #E07A5F;
}

.list-inline.li2 li {
  display: inline-flex;
}

.list-inline.li2 li b {
  margin-left: .3rem;
}

.list-inline.li2 > li:not(:last-child) {
  margin-right: 1rem;
}

.alert.alert-info {
  font-size: .95rem;
  color: #776b3b;
  padding: 1rem 2rem;
  background: #fff8da;
  border: 1px solid #776b3b30;
  border-radius: 5px;
}

.filter-result b {
  color: #e07a5f;
}

.sale-badge {
  color: #fff;
  background: #E07A5F;
  font-size: .8rem;
  padding: 2px 4px;
  border-radius: 15px;
  font-weight: normal;
}

/*#app {*/
/*  font-family: Avenir, Helvetica, Arial, sans-serif;*/
/*  -webkit-font-smoothing: antialiased;*/
/*  -moz-osx-font-smoothing: grayscale;*/
/*  color: #2c3e50;*/
/*  margin-top: 60px;*/
/*}*/


.nav-underline {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.nav-underline .nav-link {
  /*padding-right: 0;*/
  /*padding-left: 0;*/
  padding: 5px 0;
  border-bottom: 1px solid transparent;
}

.nav-underline .nav-link.active {
  font-weight: bold;
  border-bottom: 1px solid;
  /*color:#333;*/
}

.btn-sm2 {
  padding-top: .3rem !important;
  padding-bottom: .3rem !important;
}
</style>